import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { PROJECT_TASK_PREFIX_URL } from './constants/config.project-task'
import prefixToPath from '../../../../../../utils/prefix-to-path'

const LayoutPageViews = lazy(
  () => import('./pages/project/LayoutPage.Views.ProjectTask')
)
const ListPageAssignMe = lazy(
  () => import('./pages/project/ListPage.AssignMe.ProjectTask')
)
const ListPageExpired = lazy(
  () => import('./pages/project/ListPage.Expired.ProjectTask')
)
const ReportPage = lazy(() => import('./pages/project/ReportPage.ProjectTask'))

const ProjectTaskRouters: AppRouterItem[] = [
  {
    path: '/',
    element: <Navigate to={`${prefixToPath(PROJECT_TASK_PREFIX_URL)}/view`} />,
  },
  {
    path: PROJECT_TASK_PREFIX_URL,
    element: <Navigate to="view" />,
  },
  {
    path: `${PROJECT_TASK_PREFIX_URL}/view/:tabKey?`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <LayoutPageViews />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_TASK_PREFIX_URL}/view/:tabKey/:kanbanKey?`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <LayoutPageViews />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_TASK_PREFIX_URL}/view/:tabKey?`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <LayoutPageViews />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_TASK_PREFIX_URL}/assign-me`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageAssignMe />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_TASK_PREFIX_URL}/expired`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageExpired />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${PROJECT_TASK_PREFIX_URL}/report`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPage />
      </LoadingLazyComponents>
    ),
  },
]

export default ProjectTaskRouters
